import { useEffect } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";

// 로그인 관련
import Login from "./components/admin/pages/AuthPage/Login";

// 관리자 메뉴
import AdminSetting from "./components/admin/pages/AdminPage/AdminSetting";
import DetailAdmin from "./components/admin/pages/AdminPage/DetailAdmin";

// 리포트 관리
import CompanyMain from "./components/admin/pages/CompanyPage/CompanyMain";
import DetailUser from "./components/admin/pages/CompanyPage/DetailUser";

// 리포트
import Report from "./components/report/pages/Report";

// 레이아웃
import PageTemplate from "./components/admin/templates/Pagetemplate";
import FormTemplate from "./components/admin/templates/FormTemplate";

import Worklist from "./components/admin/organisms/Worklist";
import Dashboard from "./components/admin/pages/DashboardPage/Dashboard";
import AddAdmin from "./components/admin/pages/AdminPage/AddAdmin";
import AddCompany from "./components/admin/pages/AdminPage/AddCompany";
import DetailCompany from "./components/admin/pages/AdminPage/DetailCompany";
import AddBranch from "./components/admin/pages/AdminPage/AddBranch";
import DetailBranch from "./components/admin/pages/AdminPage/DetailBranch";
import Error from "./components/admin/pages/AuthPage/Error";
import IpAccessRestriction from "./components/admin/pages/AuthPage/IpAccessipAccessRestriction";
import { useDispatch, useSelector } from "react-redux";
import { hideConfirm } from "./reducer/confirmSlice";
import { hideAlert, showAlert } from "./reducer/alertSlice";
import axios from "axios";
import PrivateRoutes from "./Route/PrivateRoute";
import ScrollToTop from "./components/admin/atoms/ScrollToTop";
import { useLogout, useRefresh } from "./components/common/hook";
import AccessDenied from "./components/admin/pages/AuthPage/AccessDenied";
import Settlement from "./components/admin/organisms/Settlement";
import SettlementCount from "./components/admin/organisms/SettlementCount";
axios.defaults.baseURL = process.env.REACT_APP_API_URL;
function App() {
    const confirm = useSelector(state => state.confirm);
    const alert = useSelector(state => state.alert);
    const dispatch = useDispatch();
    const loginInfo = useSelector(state => state.login);

    const refresh = useRefresh();
    const logout = useLogout();
    const navigate = useNavigate();

    useEffect(() => {
        if (sessionStorage.getItem("isAuthenticated") == "1") {
            refresh.refetch();
        }
    },[]);

    // 응답
    const interceptor = axios.interceptors.response.use(
        (response) => {
            return response;
        },
        async (error) => {
            const { config } = error;
            
            // response 객체가 있는지 확인
            if (!error.response) {
                return Promise.reject(error);
            }
            
            const { status } = error.response;
            config.sent = true;
            
            if (status === 401) { // 토큰 재발급
                if (sessionStorage.getItem("isAuthenticated") === "1") {
                    if (config.url !== "/refresh") {
                        try {
                            await refresh.refetch();
                            // 토큰 갱신 후 원래 요청을 다시 시도
                            // return axios(config);
                        } catch (refreshError) {
                            // 갱신 실패 시 로그아웃 처리
                            console.log("logout");
                            await logout.refetch();
                            return Promise.reject(refreshError);
                        }
                    } else {
                        await logout.refetch();
                    }
                }
            } else if (status >= 500) {
                navigate("/error/500");
            } else {
                return Promise.reject(error);
            }
        }
    );

    // useEffect(() => {
    
    //     return () => {
    //         axios.interceptors.response.eject(interceptor);
    //     }
    // })


    return (
        <div className="App">
            <ScrollToTop/>
            <Routes>
                {   
                    <>
                        {/* PRIVATE level-4 (일반) */}
                        <Route element={<PrivateRoutes authentication={4}/>}>
                            <Route element={<PageTemplate />}>
                                {/* 업체/지점 관리 */}
                                <Route path="main">
                                    <Route path=":type/:companyId/:branchId" element={<CompanyMain />} />
                                </Route>

                                {/* 고객 */}
                                <Route path="detail">
                                    <Route path="user/:companyId/:branchId/:id" element={<DetailUser />} />
                                </Route>
                            </Route>
                        </Route>

                        {/* PRIVATE level-3 (지점) */}
                        <Route element={<PrivateRoutes authentication={3}/>}>
                            <Route element={<PageTemplate />}>
                                {/* 관리자 메뉴 */}
                                <Route path="admin">
                                    {/* 리스트 */}
                                    <Route path="list/:type" element={<AdminSetting />} />
                                    {/* 상세 */}
                                    <Route path="detail">
                                        {/* 지점 */}
                                        <Route path="branch/:id" element={<DetailBranch />} />
                                    </Route>
                                </Route>
                            </Route>
                        </Route>

                        {/* PRIVATE level-2 (업체) */}
                        <Route element={<PrivateRoutes authentication={2}/>}>
                            <Route element={<PageTemplate />}>
                                {/* 관리자 메뉴 */}
                                <Route path="admin">
                                    <Route path="list/:type" element={<AdminSetting />} />

                                    {/* 상세 */}
                                    <Route path="detail">
                                        {/* 지점 */}
                                        <Route path="branch/:id" element={<DetailBranch />} />
                                        {/* 업체 */}
                                        <Route path="company/:id" element={<DetailCompany />} />
                                    </Route>
                                    {/* 추가 */}
                                    <Route path="add">
                                        {/* 지점 */}
                                        <Route path="branch" element={<AddBranch />} />
                                    </Route>
                                </Route>
                            </Route>
                        </Route>

                        {/* PRIVATE level-1 (최고) */}
                        <Route element={<PrivateRoutes authentication={1}/>}>
                            <Route element={<PageTemplate />}>
                                {/* ����� ���시���� */}
                                <Route path="dashboard" element={<Dashboard />} />
                                <Route path="worklist" element={<Worklist />} />
                                <Route path="settlement" element={<Settlement />} />
                                <Route path="settlementCount" element={<SettlementCount />} />
                                {/* 관리자 메뉴 */}
                                <Route path="admin">
                                    {/* 상세 */}
                                    <Route path="detail">
                                        {/* 관리자 */}
                                        <Route path="chief/:id" element={<DetailAdmin />} />
                                    </Route>
                                    {/* 추가 */}
                                    <Route path="add">
                                        {/* 관리자 */}
                                        <Route path="chief" element={<AddAdmin />} />
                                        {/* 업체 */}
                                        <Route path="company" element={<AddCompany />} />
                                    </Route>
                                </Route>
                            </Route>
                        </Route>
                    </>
                }

                {/* 리포트 */}
                {/* <Route path="report" element={<PrivateRoutes authentication={1}/>}> */}
                <Route path="report">
                    <Route path=":id/:password" element={<Report />} />
                </Route>
                
                {/* 인증 */}
                <Route element={<PrivateRoutes authentication={false}/>}>
                    <Route path="/auth" element={<FormTemplate />}>
                        <Route path="login" element={<Login />} />
                    </Route>
                </Route>

                {/* PUBLIC */}
                <>
                    <Route path="/" element={<Navigate to="/auth/login"/>}/>
                    <Route path="*" element={<Error 
                                                h1="404" 
                                                p={<>존재하지 않는 주소를 입력하셨거나<br/>요청하신 페이지 주소가 변경 또는 삭제되어 찾을 수 없습니다.</>} 
                                                link="/dashboard" btn="메인으로"
                                            />}  
                    />
                    <Route path="/error/400" element={<Error 
                                                h1="404" 
                                                p={<>존재하지 않는 주소를 입력하셨거나<br/>요청하신 페이지 주소가 변경 또는 삭제되어 찾을 수 없습니다.</>} 
                                                link="/dashboard" btn="메인으로"
                                            />}  
                    />
                    <Route path="/error/500" element={<Error 
                                                h1="500" 
                                                p={<>현재 해당 페이지에 접속할 수 없습니다.
                                                    <br/>잠시 후 다시 확인해 주세요.</>} 
                                                link={-1} btn="새로고침"
                                            />}  
                    />
                    <Route path="/error/ipAccessRestriction" element={<IpAccessRestriction />}  />
                    <Route path="/error/accessDenied" element={<AccessDenied to="/auth/login" />}  />
                </>
            </Routes>
            <Modal show={confirm.value} centered size="sm" 
                backdrop="static"
                onHide={() => {
                    dispatch(hideConfirm())}
                }
            >
                <Modal.Body className="text-center" style={{lineHeight: 1.2}}>
                    {confirm.msg}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => {dispatch(hideConfirm())}}>
                        취소
                    </Button>
                    <Button variant="primary" onClick={() => {
                        confirm.func();
                    }}>
                        {confirm.btnText}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={alert.value} centered size="sm" 
                onHide={() => {
                    alert.func();
                    dispatch(hideAlert())
                }}
            >
                <Modal.Body className="text-center" style={{lineHeight: 1.2}}>
                    {alert.msg}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary"
                    onClick={() => {
                        alert.func();
                        dispatch(hideAlert())
                    }}>
                        확인
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
    
}

export default App;
